
import React from 'react';

import PropTypes from 'prop-types';

import _ from 'underscore';
import { securityAction } from '@bingads-webui-clientcenter/pidl-service-smart';
import { PidlUtil } from '../utils/pidl-util';
import { PropTypesGenericPidl, PropTypesDefaultGenericPidl } from '../shapes';
import { ValidatorPidlForm } from '../pidl-forms/validator-pidl-form';
import type {
  PidlError,
  PidlEventName,
  PidlEventParameters,
  PidlInstance,
  ValidatorProps,
  ValidatorState,
} from '../types';

export class Validator extends React.Component<ValidatorProps, ValidatorState> {
  static propTypes = {
    ...PropTypesGenericPidl,
    piData: PropTypes.shape({
      Market: PropTypes.string,
      CtpPiId: PropTypes.number,
      MtPiId: PropTypes.number,
      PiType: PropTypes.string,
    }).isRequired,
    eventHandlers: PropTypes.objectOf(PropTypes.func).isRequired,
    parentElementId: PropTypes.string.isRequired,
    permissions: PropTypes.shape({}),
  };

  static defaultProps: Partial<ValidatorProps> = {
    ...PropTypesDefaultGenericPidl,
    permissions: {},
  };


  pidlUtil: PidlUtil;

  constructor(props: ValidatorProps) {
    super(props);
    this.state = {
      pidlInstance: null,
      pidlFormId: _.uniqueId('pidl-container-'),
    };
    this.pidlUtil = new PidlUtil(props);
  }

  componentDidMount() {
    const pidlCallbacks = {
      successCallback: () => this.successCallback(),
      goHomeCallback: () => this.goHomeCallback(),
    };

    const displayOptions = {
      containerId: this.state.pidlFormId,
      showPlaceholderInTextbox: true,
    };


    const errorHandler = (error: PidlError) => this.pidlInstanceErrorHandler(error);

    this.pidlUtil.getPidlInstance({
      piData: this.props.piData,
      pidlCallbacks,

      docDisplayEventHandler: (eventName: PidlEventName, parameters?: PidlEventParameters) => this.docDisplayEventHandler(eventName, parameters),
      displayOptions,

      errorHandler: (error: PidlError) => this.pidlInstanceErrorHandler(error),
      securityAction: securityAction.PaymentInstrumentUpdate,
    }).then((pidlInstance: PidlInstance) => this.setState({
      pidlInstance,
    })).catch(errorHandler);
  }


  pidlInstanceErrorHandler(error: PidlError) {
    this.props.eventHandlers.handleTerminatingError(error);
  }

  successCallback = () => {
    this.pidlUtil.logger.succeed();
    this.props.eventHandlers.handleValidationSuccess();
  };

  goHomeCallback = () => {
    this.pidlUtil.logger.userFail('CancelClicked');
    this.props.eventHandlers.handleGoHome(this.props.parentElementId);
  };


  docDisplayEventHandler(eventName: PidlEventName, parameters?: PidlEventParameters) {
    let error;
    switch (eventName) {
      case 'pageRendering':
        this.props.eventHandlers.handleProcessingStart();
        break;
      case 'pageRendered':
        this.pidlUtil.logger.succeed('renderPidl');
        this.props.eventHandlers.handleRemoveTitleText();
        this.props.eventHandlers.handlePidlDocRendered();
        break;
      case 'error':
        error = parameters && parameters.error;
        this.pidlUtil.logger.validationFail('submit', error);
        this.props.eventHandlers.handleProcessingComplete();
        break;
      default:
        break;
    }
  }

  render() {
    return (
      <div className="validator-container">
        <h3 className="page-header type-bold">{this.props.i18n.getString(_TL_('Sepa Validation'))}</h3>
        <div className="row">
          <div className="col-xs-8">
            <ValidatorPidlForm
              pidlInstance={this.state.pidlInstance}
              pidlUtil={this.pidlUtil}
              piData={this.props.piData}
              pidlFormId={this.state.pidlFormId}
            />
          </div>
        </div>
      </div>
    );
  }
}
